const styleSheet = (theme: any) => ({
  loader: {
    width: "775px",
    height: "775px",
    backgroundColor: "#FFFFFF",
    position: "absolute",
    zIndex: 9,
    top: "275px"
  },
  center: {
    position: "absolute",
    top: "45%",
    left: "45%"
  }
});

export default styleSheet;
try {
    // @ts-ignore
    styles.displayName = "styles";
    // @ts-ignore
    styles.__docgenInfo = { "description": "", "displayName": "styles", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/GoodData/dashboards/ProfileDetails/styles.ts#styles"] = { docgenInfo: styles.__docgenInfo, name: "styles", path: "src/shared/containers/GoodData/dashboards/ProfileDetails/styles.ts#styles" };
}
catch (__react_docgen_typescript_loader_error) { }